import Mitt from "mitt";

export const paymentsBus = Mitt();

export const PAYMENT_EVENTS = {
  RELOAD_LIST: "RELOAD_LIST",
};
